// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__ZC41c","insightsList":"newBusinessInsightsMenu_insightsList__28_Wq","active":"newBusinessInsightsMenu_active__3wN17"};